module.exports = __webpack_public_path__ + "static/media/cover.7f720c56.png";